import { render, staticRenderFns } from "./NotificationsNotBlockMobile.vue?vue&type=template&id=de5f09f6&scoped=true"
import script from "./NotificationsNotBlockMobile.vue?vue&type=script&lang=js"
export * from "./NotificationsNotBlockMobile.vue?vue&type=script&lang=js"
import style0 from "./NotificationsNotBlockMobile.vue?vue&type=style&index=0&id=de5f09f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5f09f6",
  null
  
)

export default component.exports